module.exports = __webpack_public_path__ + "img/zhxy_image_6.5b5863f7.png";